export default "//file.bilionpass.com/japandx-portal/0.1.22/static/img/ZenKakuGothicNew-Bold.0081ceda-e9bb0e.ttf";